module.exports = __webpack_public_path__ + "img/fun-to-drive.dfefc6e7.jpg";